var DynamicContent = function(){

    'use strict';

    var $ = jQuery,
        instances = [],
        html = [];

    // Layout no data html
    html.basic = '<p>Ningún resultado para mostrar</p>';

    function onReady() {
        $('.module.dynamic-content').each(function () {
            instances.push(initInstance($(this)));
        });
    }    

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id'),
            params = window.dataModules[id],
            paged = null;

        // Private methds
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        function render(responseHtml, filter) {
            var $response = $(responseHtml);
            var $container = $view.find('.items-container .load-more-container');
            var $newItems = $response.find('.items-container .load-more-container .load-more-item');
            if (filter === true) {
                $container.empty();
            }
            if (filter === true && responseHtml === '') {
                $container.append(html[params.layout]);
            }
            
            $container.append($newItems);
        }

        function sendData(filter) {
            // UI sending data
            var $button = $view.find('#load-more');
            $button.addClass('deactivate');
            $button.addClass('loading');

            $.ajax({
                url: params.url,
                method: 'POST',
                dataType: 'html',
                data: params
            })
            .done(function (responseData) {
                var error = null;
                try {
                    error = JSON.parse(responseData);
                }
                catch(e) {
                    error = {};
                }
                if (!error.error) {
                    render(responseData, filter);
                    $button.removeClass('deactivate');
                    $button.removeClass('loading');
                }
                else {
                    $button.removeClass('loading');
                    render('', filter);
                    // alert('No hay mas páginas');
                }
            })
            .error(function () {
                // Asignamos el evento otra vez por si hay que repetir la acción
                $button.removeClass('deactivate');
                $button.removeClass('loading');
            });
        }      
 
        function filterHasChange(){
            if($(this).val() !== 0){
                filterLoadContent();
            }
        }

        function buttonSearchSelected(){
            if($view.find('.filters-container input[name="search"]').val() !== ''){
                filterLoadContent();
            }
        }

        function filterLoadContent(){
            // Reiniciamos la página para que aparezca desde el primer resultado
            params.paged = 1;

            $view.find('.filters-container').children().each(function(){
                if(parseInt($(this).val()) !== 0 && $(this).val() !== ''){
                    params[$(this).attr('name')] = $(this).val();
                }else{
                    delete params[$(this).attr('name')];
                }
            });

            sendData(true);
        }

        function onLoadMoreClick (e) {
            e.preventDefault();
            var $button = $(this);

            // Anulamos el evento click del boton
            if ($button.hasClass('deactivate') === true) {
                return;
            }

            // Next page
            paged++;
            params.paged = paged;
            params.paged = 1;

            sendData();
        }

        // instance object
        var instance = {
            init: function () {
                // Filters functionallity
                $view.find('.filters-container').children().on('change', filterHasChange);
                $view.find('.filters-container button.search').on('click', buttonSearchSelected);
                // Take the number of page
                paged = (!params.paged) ? 1 : params.paged;
                $view.find('#load-more').on('click' , onLoadMoreClick);
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

DynamicContent();
